import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'

import { LayoutWrapper } from '@ui/business-components/LayoutWrapper'
import { Articles } from '@ui/business-components/Articles'
import SingleArticle from '@ui/pages/LearningStudioArticle/SingleArticle'
import { use404Redirect } from '@app/hooks/use404Redirect'
import { Meta } from '@ui/blocks/Meta'
import {
  articleSelector,
  articleStatusSelector,
  categoryArticlesSelector,
  getArticle,
  getCategory,
  resetStudioStatus
} from '@app/store/learningStudio'

const LearningStudioArticle = () => {
  const { article, category } = useParams<Record<string, string>>()
  const articleSlug = `${category}/${article}`
  const dispatch = useDispatch()
  const articleData = useSelector(articleSelector)
  const articlesList = useSelector(categoryArticlesSelector)
  const loadingStatus = useSelector(articleStatusSelector)
  const redirect404 = use404Redirect(resetStudioStatus)

  useEffect(() => {
    const is404 = loadingStatus === 'success' && articleData === null
    if (is404) {
      redirect404()
    } else {
      dispatch(getArticle(articleSlug))
      dispatch(getCategory(category))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleSlug])

  return (
    <>
      <Meta
        title={articleData?.title || 'Elemy | ABA Therapy'}
        description={articleData?.seoData?.description || 'Learning Studio article'}
      />
      <LayoutWrapper pusher={false} headerTransparent headerProgressBar>
        <SingleArticle data={articleData} articleSlug={articleSlug} />
        <Articles title="Related Articles" articles={articlesList} currentArticleId={articleData?.id} />
      </LayoutWrapper>
    </>
  )
}

export default hot(LearningStudioArticle)
